import { ContextProviderProps } from 'config/types'
import { createContext, Dispatch, SetStateAction, useState } from 'react'

interface ViewContextType {
  view: boolean
  setView: Dispatch<SetStateAction<boolean>>
}

const ViewContext = createContext<ViewContextType>({
  view: false,
  setView: () => {},
})

//TODO : currently this provider is not being used in the application
const TemplateProvider = ({ children }: ContextProviderProps) => {
  const [view, setView] = useState(false)

  return (
    <ViewContext.Provider value={{ view, setView }}>
      {children}
    </ViewContext.Provider>
  )
}

export { TemplateProvider, ViewContext }
